import { SnapshotIn } from 'mobx-state-tree'
import { Cover } from 'src/api/models/Enclosure/Cover'
import { front, top, right, bottom, left, back } from 'src/constants/sides'

export const printedcircuitboardProperties = {
  width: { value: 160 },
  length: { value: 100 },
  thickness: { value: 1.6 },
  solderSide: {
    border: {
      top: { value: 3 },
      bottom: { value: 3 },
      left: { value: 0 },
      right: { value: 0 }
    },
    height: { value: 5 }
  },
  componentSide: {
    border: {
      top: { value: 3 },
      bottom: { value: 3 },
      left: { value: 0 },
      right: { value: 0 }
    },
    height: { value: 5 }
  }
}

const coverPlate = { properties: { thickness: { value: 3 } } }

const cover: SnapshotIn<typeof Cover> = {
  plates: {
    edges: ([front, top, right, bottom, left, back] as const).map(side => ({
      properties: { side },
      node: coverPlate
    }))
  }
}

export const coverEdge = {
  node: cover
}
